
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ShoppingBag, Info, BookOpen, Star, ArrowRight, Users, LogIn, UserPlus, BookMarked } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import { useAuth } from "@/contexts/AuthContext";

const NavigationMenu = () => {
  const isMobile = useIsMobile();
  const { isAuthenticated } = useAuth();

  const menuItems = [
    {
      title: "METRADE Premium",
      path: "/strategies",
      icon: <Star className="h-5 w-5 text-[#FBC528]" />,
      highlight: false,
    },
    {
      title: "Premium Subscription",
      path: "/pricing",
      icon: <ShoppingBag className="h-5 w-5 text-[#FBC528]" />,
      highlight: false,
    },
    {
      title: "How It Works",
      path: "/how-it-works",
      icon: <Info className="h-5 w-5 text-[#FBC528]" />,
      highlight: false,
    },
    {
      title: "Marketplace",
      path: "/marketplace",
      icon: <ShoppingBag className="h-5 w-5 text-[#FBC528]" />,
      highlight: false,
    },
    {
      title: "About Us",
      path: "/about-us",
      icon: <Users className="h-5 w-5 text-[#FBC528]" />,
      highlight: false,
    },
    {
      title: "Knowledge Hub",
      path: "/knowledge-hub",
      icon: <BookOpen className="h-5 w-5 text-[#FBC528]" />,
      highlight: false,
    },
    {
      title: "Blog",
      path: "/knowledge-hub/blog",
      icon: <BookMarked className="h-5 w-5 text-[#FBC528]" />,
      highlight: false,
    },
    ...(isAuthenticated ? [] : [
      {
        title: "Get Started",
        path: "/signup",
        icon: <ArrowRight className="h-5 w-5 text-[#FBC528]" />,
        highlight: false,
      }
    ]),
  ];

  // Add auth menu items for mobile if not logged in
  const authMenuItems = !isAuthenticated ? [
    {
      title: "Log In",
      path: "/auth",
      icon: <LogIn className="h-5 w-5 text-[#FBC528]" />,
      highlight: true,
    },
    {
      title: "Sign Up",
      path: "/signup",
      icon: <UserPlus className="h-5 w-5 text-[#FBC528]" />,
      highlight: true,
    }
  ] : [];

  // Combined menu items for display
  const displayMenuItems = isMobile 
    ? [...authMenuItems, ...menuItems] 
    : menuItems;

  return (
    <motion.nav 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="flex flex-col h-full bg-corporate-primary-100 rounded-r-xl"
    >
      <div className="flex-grow overflow-y-auto py-4">
        <div className="space-y-1 px-3">
          {displayMenuItems.map((item, index) => (
            <motion.div
              key={`${item.path}-${index}`}
              initial={{ x: -20, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ delay: index * 0.05, duration: 0.3 }}
            >
              <Link 
                to={item.path} 
                className={`group flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200
                  text-white hover:bg-white/10 ${item.highlight ? 'bg-white/10' : ''}`}
              >
                <span className="flex items-center justify-center w-8 h-8">{item.icon}</span>
                <span className="font-medium">{item.title}</span>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
      
      <div className="px-3 py-4 border-t border-white/20 mt-auto">
        <div className="flex flex-col gap-2">
          <Link 
            to="/privacy" 
            className="text-white text-sm px-4 py-3 rounded-lg hover:bg-white/10 transition-colors"
          >
            Privacy Policy
          </Link>
          <Link 
            to="/terms" 
            className="text-white text-sm px-4 py-3 rounded-lg hover:bg-white/10 transition-colors"
          >
            Terms of Service
          </Link>
          <Link 
            to="/disclaimer" 
            className="text-white text-sm px-4 py-3 rounded-lg hover:bg-white/10 transition-colors"
          >
            Risk Disclaimer
          </Link>
        </div>
      </div>
    </motion.nav>
  );
};

export default NavigationMenu;
